import { useTranslation } from '@web_opxp/language';
import * as React from 'react';
import SubsciptionConditions from '../subscriptionConditions/SubscriptionConditions';
import './MoneybackGuarantee.scss';

export interface IMoneybackGuaranteeProps {
  country?: string;
}

const MoneybackGuarantee: React.FC<IMoneybackGuaranteeProps> = ({ country }) => {
  const { t } = useTranslation();
  const moneybackText = t('Subscribe.Moneyback.Moneyback');
  const imageLink = t('Subscribe.Moneyback.Imagelink');
  const questions = t('Subscribe.Moneyback.Questions');
  const showConditions = !country || country.toUpperCase() === 'DE';
  return (
    <div>
      <div className="money-back-widget">
        <div className="money-back-flex-line">
          <img src={imageLink} alt={moneybackText} />
        </div>
        <div className="money-back-flex-line">
          <p>
            {moneybackText}
            {showConditions && <SubsciptionConditions />}
          </p>
        </div>
        <div className="money-back-flex-line">
          <p>{questions}</p>
        </div>
      </div>
    </div>
  );
};

export default MoneybackGuarantee;
